import CONSTANTS from '../Constants'
import { TypeObject } from '../Models'
import { updateAttributesAsset } from '../Store/Slice/asset-definition.slice'
import { getSelectedAttributeDetails, isValidArray, updatingSortOrderValue } from './Util'

export const assetDefSelectedAttributes = (
  categories: any[] = [],
  storedAsset: any = {},
): { selectedAttributes: any[]; selectedAssetGroupAttributes: any[] } => {
  const selectedAttributes: any[] = []
  const selectedAssetGroupAttributes: any[] = []

  if (isValidArray(categories)) {
    categories.forEach((metaCategory) => {
      selectedAttributes.push({
        metaCategoryKey: metaCategory.categoryKey,
        metaCategoryAttributes: [],
      })
    })
  }

  if (isValidArray(storedAsset?.assetGroupAttributes)) {
    storedAsset.assetGroupAttributes.forEach((attr: any) => {
      selectedAssetGroupAttributes.push(attr)
    })
  }
  if (isValidArray(storedAsset?.attributes)) {
    selectedAttributes.forEach((copySelectedAttr) => {
      const { metaCategoryKey = '' } = copySelectedAttr
      if (metaCategoryKey) {
        const selectedAttrs = storedAsset.attributes.find(
          (item: any) => item?.metaCategory === metaCategoryKey,
        )
        copySelectedAttr.metaCategoryAttributes = selectedAttrs?.metaAttributes || []
      }
    })
  }

  return {
    selectedAttributes,
    selectedAssetGroupAttributes,
  }
}

const handleComplexTypeAttributes = (
  attributeRef: any[],
  attributes: any,
  metaCategoryAttributes: any,
) => {
  const complexAttributesRef = getSelectedAttributeDetails(attributeRef, attributes)
  for (const attref of complexAttributesRef) {
    const findMetaAttribute = metaCategoryAttributes.find(
      (item: TypeObject) => item.fieldName === attref.fieldName,
    )
    if (!findMetaAttribute) {
      metaCategoryAttributes.push(attref)
    }

    // Recursively handle nested COMPLEXTYPE attributes
    if (attref?.fieldType === 'COMPLEXTYPE' && attref?.attributeRef?.length) {
      handleComplexTypeAttributes(attref.attributeRef, attributes, metaCategoryAttributes)
    }
  }
}

export const updateCategoryListAttributes = (
  isAssetGroupTab: any,
  index: number,
  newValue: any[],
  categoryKey: any,
  reason: string,
  forEdit: any,
  assetData: any,
  selectedAttributes: any,
  setSelectedAttributes: any,
  dispatch: any,
  attributes: any,
) => {
  if (reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.INPUT) {
    return
  }
  if (reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.CLEAR) {
    if (forEdit && assetData?.contentCreated) {
      return
    }
    let copyArr
    const newValue: any[] = []
    if (isAssetGroupTab) {
      copyArr = newValue
    } else {
      copyArr = [...selectedAttributes]
      copyArr[index].metaCategoryAttributes = newValue
    }
    setSelectedAttributes(copyArr)
    dispatch(updateAttributesAsset({ categoryKey, newValue, isAssetGroupTab }))
  }
  if (reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.SELECTOPTION) {
    newValue = updatingSortOrderValue(newValue)
    let copyArr
    if (isAssetGroupTab) {
      copyArr = newValue
    } else {
      copyArr = [...selectedAttributes]
      copyArr[index].metaCategoryAttributes = newValue
    }
    const latestAttribute = newValue[newValue.length - 1]
    if (latestAttribute?.fieldType === 'COMPLEXTYPE' && latestAttribute?.attributeRef?.length) {
      handleComplexTypeAttributes(latestAttribute.attributeRef, attributes, newValue)
    }
    setSelectedAttributes(copyArr)
    if (typeof newValue === 'object')
      dispatch(updateAttributesAsset({ categoryKey, newValue, isAssetGroupTab }))
  }
  if (reason === CONSTANTS.AUTOCOMPLETE_EVENT_TYPES.REMOVEOPTION) {
    if (forEdit && assetData?.contentCreated) {
      return
    }
    newValue = updatingSortOrderValue(newValue)
    let copyArr
    if (isAssetGroupTab) {
      copyArr = newValue
    } else {
      copyArr = [...selectedAttributes]
      copyArr[index].metaCategoryAttributes = newValue
    }
    setSelectedAttributes(copyArr)
    if (typeof newValue === 'object')
      dispatch(updateAttributesAsset({ categoryKey, newValue, isAssetGroupTab }))
  }
}

export const onDragEndCategoryList = (
  event: any,
  data: any,
  dispatch: any,
  categoryKey: any,
  isAssetGroupTab = false,
) => {
  const { source = {}, destination = {} } = event || {}
  const sourceIndex = source?.index - 1
  const destinationIndex = destination?.index - 1
  let copyData = JSON.parse(JSON.stringify(data))
  if (isValidArray(data)) {
    const element = copyData?.slice(sourceIndex, sourceIndex + 1)[0]
    copyData.splice(sourceIndex, 1)
    copyData.splice(destinationIndex, 0, element)
    copyData = updatingSortOrderValue(copyData)
    data = copyData
  }
  const newValue = data
  if (typeof newValue === 'object')
    dispatch(updateAttributesAsset({ categoryKey, newValue, isAssetGroupTab }))
}

type Attribute = {
  sortOrder: number
  fieldType?: string
  attributeRef?: { _id: string }[]
  [key: string]: any
}

type Asset = {
  assetGroupAttributes: Attribute[]
  attributes: {
    metaCategory: string
    metaAttributes: Attribute[]
  }[]
}

export const processAssetDefinationMetaAttributes = (
  asset: Asset,
  categoryKey: string,
  isAssetGroupTab: number,
) => {
  let attributes: Attribute[] = []

  if (isAssetGroupTab && categoryKey === CONSTANTS.CATEGORIES.CONTENT_MEDIA_VIDEO) {
    attributes = asset.assetGroupAttributes || []
  } else {
    attributes =
      asset.attributes?.find((x) => x?.metaCategory === categoryKey)?.metaAttributes || []
  }

  const sortedMetaAttributes = [...attributes].sort(
    (x, y) => (x?.sortOrder || 0) - (y?.sortOrder || 0),
  )

  const complexTypeData = sortedMetaAttributes.reduce<string[]>((pre, cur) => {
    if (cur.fieldType === 'COMPLEXTYPE') {
      return [...pre, ...(cur?.attributeRef?.map((item) => item._id) || [])]
    }
    return pre
  }, [])

  return { sortedMetaAttributes, complexTypeData }
}

export const deleteAssetDefinationAttributeById = (data: any[], targetId: string): any[] => {
  const idsToDelete = new Set<string>()
  idsToDelete.add(targetId)
  data.forEach((item) => {
    if (item.fieldType === 'COMPLEXTYPE' && item.attributeRef?.length) {
      if (item._id === targetId) {
        idsToDelete.add(item._id)
        item.attributeRef.forEach((ref: any) => {
          idsToDelete.add(ref._id)
        })
      } else {
        item.attributeRef = item.attributeRef.filter((ref: any) => {
          if (ref._id === targetId) {
            idsToDelete.add(targetId)
          }
          return ref._id !== targetId
        })
        if (item.attributeRef.length === 0) {
          idsToDelete.add(item._id)
        }
      }
    } else if (item._id === targetId) {
      idsToDelete.add(targetId)
    }
  })
  return data.filter((item) => !idsToDelete.has(item._id))
}
